/* eslint-disable react/jsx-no-duplicate-props */
/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

// Images
import macbook from "assets/images/contact_image.jpg";
import { useState } from "react";
import MKAlert from "components/MKAlert";
import { db } from "../../../../config";

function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errMessage, setErrMessage] = useState("");

  async function findUserByEmail(email) {
    setLoading(true);
    const usersCollection = collection(db, "email_subscribtion"); // Your collection name
    const q = query(usersCollection, where("email", "==", email));

    try {
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        // Found at least one document
        // const doc = querySnapshot.docs[0]; // Get the first matching document
        // console.log("Document found:", doc.data());
        setLoading(false);
        return false;
      } else {
        setLoading(false);
        return true;
      }
    } catch (error) {
      console.error("Error getting document:", error);
      return null;
    }
  }

  const handleSubmit = async () => {
    setLoading(true);
    setMessage("");
    setErrMessage("");

    const docRef = await addDoc(collection(db, "email_subscribtion"), {
      email: email,
      subscription_date: new Date().toISOString(), // optional: add timestamp
      status: "active", // optional: default status
    });

    if (docRef.id) {
      setMessage("Successfully subscribed!");
      setLoading(false);
      setTimeout(() => {
        setMessage("");
        setEmail("");
      }, 5000);
    } else {
      setErrMessage("Subscription failed. Please try again.");
      setLoading(false);
      setTimeout(() => {
        setErrMessage("");
      }, 5000);
    }
  };

  function validateEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  return (
    <MKBox component="section" pt={6} my={6}>
      <Container>
        <Grid container alignItems="center">
          <Grid item xs={12} md={6} sx={{ ml: { xs: 0, lg: 3 }, mb: { xs: 12, md: 0 } }}>
            <MKTypography variant="h4">Be the first to see our news</MKTypography>
            <MKTypography variant="body2" color="text" mb={3}>
              Your company may not be in the software business, but eventually, a software company
              will be in your business.
            </MKTypography>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <MKInput
                  type="email"
                  label="Email Here..."
                  fullWidth
                  placeholder="Enter your email"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <MKButton
                  variant="gradient"
                  color="info"
                  sx={{ height: "100%" }}
                  onClick={async () => {
                    console.log(
                      "email found:",
                      validateEmail(email) && (await findUserByEmail(email))
                    );
                    if (validateEmail(email) && (await findUserByEmail(email))) {
                      handleSubmit();
                    } else if (!validateEmail(email)) {
                      setErrMessage("Please enter a valid email!");
                      setTimeout(() => {
                        setErrMessage("");
                      }, 5000);
                    } else if ((await findUserByEmail(email)) === false) {
                      setErrMessage("You already have subscribed");
                      setTimeout(() => {
                        setErrMessage("");
                      }, 5000);
                    }
                  }}
                  disabled={loading}
                >
                  {loading ? "Subscribing..." : "Subscribe"}
                </MKButton>
              </Grid>

              <Grid item xs={8}>
                {message && (
                  <>
                    <MKAlert color="success"> {message && <p>{message}</p>} </MKAlert>
                  </>
                )}
                {errMessage && (
                  <>
                    <MKAlert color="error"> {errMessage && <p>{errMessage}</p>} </MKAlert>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={5} sx={{ ml: "auto" }}>
            <MKBox position="relative">
              <MKBox component="img" src={macbook} alt="macbook" width="80%" borderRadius="15px" />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Newsletter;
